import { createSlice } from "@reduxjs/toolkit";
import {
  // getTeacherBaselineThunk,
  getMasterStudActTopicsThunk,
  getTeacherBaselineFlnThunk,
  getTeacherBaselineEceThunk,
  getTeacherBaselineCommunityThunk,
  createTeacherBaselineThunk,
  updateTeacherBaselineThunk,
  deleteTeacherBaselineThunk,
} from "./FlnTopicsThunk";

const initialState = {
  data: [],
  topics: [],
  loading: false,
  status: "",
  message: "",
  topicId: "",
  topicName: "",
  usertype: "fellow",
  language: "od",
  assessmentType: "",
  clas: "",
  subject: "",
  disable_content_button: true,
};

const FlnTopicsSlice = createSlice({
  name: "flntopicsslice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.assessmentType = "";
      state.clas = "";
      state.subject = "";
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.assessmentType = "";
      state.clas = "";
      state.subject = "";
      state.data = [];
      state.disable_content_button = true;
    },
    assessmentType_change: (state, action) => {
      state.assessmentType = action.payload;
      state.clas = "";
      state.subject = "";
      state.data = [];
      state.disable_content_button = true;
    },
    clas_change: (state, action) => {
      state.clas = action.payload;
      state.subject = "";
      state.data = [];
      state.disable_content_button = true;
    },
    subject_change: (state, action) => {
      state.subject = action.payload;
      state.data = [];
      state.topicId = "";
      state.topicName = "";
      state.disable_content_button = true;
    },
    clearData: (state) => {
      state.data = [];
      state.loading = false;
      state.status = "";
      state.message = "";
    },
  },
  extraReducers: {
    [getMasterStudActTopicsThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getMasterStudActTopicsThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getMasterStudActTopicsThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getTeacherBaselineFlnThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineFlnThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineFlnThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getTeacherBaselineEceThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineEceThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineEceThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getTeacherBaselineCommunityThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineCommunityThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineCommunityThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createTeacherBaselineThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createTeacherBaselineThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createTeacherBaselineThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateTeacherBaselineThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateTeacherBaselineThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateTeacherBaselineThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  usertype_change,
  language_change,
  clas_change,
  subject_change,
  assessmentType_change,
  clearData,
} = FlnTopicsSlice.actions;

export default FlnTopicsSlice.reducer;
